import { toAdminAssessmentSearchQuery, ToSearchQuery } from '@hb/react'
import { BaseQuery, CLAIMS, CollectionFilter, PregnancyClaim } from '@hb/shared'
import { DataListTab } from '../../../types'
import { claimsColumns } from '../../DataList/columns/claims'
import { getRowBackground, getRowDarkBackground } from '../../DataView/utils'
import {
  getPresetAssessmentFilters,
  getTransferredBackgroundColor,
  getTransferredDarkBackgroundColor,
  nextActionSort,
} from './common'
import { AssessmentSearchTip } from './search'

const getClaimBackgroundColor = (item: PregnancyClaim, index: number) => {
  if (item.deliveredOn === Infinity) {
    return getTransferredBackgroundColor(index)
  }
  return getRowBackground(index)
}

const getClaimDarkBackgroundColor = (item: PregnancyClaim, index: number) => {
  if (item.deliveredOn === Infinity) {
    return getTransferredDarkBackgroundColor(index)
  }
  return getRowDarkBackground(index)
}

const getClaimsBaseQuery = (
  archived: boolean,
  midwifeId: string | null,
  complaints: boolean,
): BaseQuery<PregnancyClaim> => {
  const filters: CollectionFilter<PregnancyClaim>[] = [
    [complaints ? 'assessmentOnComplaintsList' : 'assessmentOnClaimsList', '==', true],
  ]
  // const filters: CollectionFilter<Claim>[] = []
  filters.push(['archived', '==', archived])
  if (midwifeId) {
    filters.push(['midwifeId', '==', midwifeId])
  }
  return {
    collection: CLAIMS,
    filters,
  }
}

export const getClaimTab = (
  midwifeId: string | null,
  complaints: boolean,
): DataListTab<PregnancyClaim> =>
  // TODO: remove hasComplaints global filter
  ({
    baseQuery: getClaimsBaseQuery(false, midwifeId, complaints),
    columns: claimsColumns,
    defaultSort: nextActionSort,
    // secondarySort: secondaryNextActionSort,
    searchStringPath: 'stringified',
    presetFilters: getPresetAssessmentFilters(),
    searchTip: AssessmentSearchTip,
    toSearchQuery: toAdminAssessmentSearchQuery as ToSearchQuery<PregnancyClaim>,
    // rightJustifyTab: true,
    itemName: 'Claim',
    getItemBackgroundColor: getClaimBackgroundColor,
    getItemDarkBackgroundColor: getClaimDarkBackgroundColor,
  })
